import { createSlice } from '@reduxjs/toolkit';

import { handleGetAthleteGenders } from './actions';
import { IAthleteGendersState } from './slice.interface';

const initialState: IAthleteGendersState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const athleteGendersSlice = createSlice({
  name: 'athlete-genders',
  initialState,
  reducers: {
    removeAthleteGenders: (state: IAthleteGendersState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAthleteGenders.pending, (state: IAthleteGendersState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAthleteGenders.rejected, (state: IAthleteGendersState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAthleteGenders.fulfilled, (state: IAthleteGendersState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeAthleteGenders } = athleteGendersSlice.actions;

export default athleteGendersSlice.reducer;
